(function ($) {
  var CAP = 50; // set to null to disable cap

  function getSectionIdFromEvent(e) {
    // variantChange is triggered on the product container
    var $container = $(e && e.target ? e.target : null);
    var sid = $container.attr('data-section-id');
    if (sid) return sid;

    // fallback: find any product section
    var $any = $('[data-section-type="product"]').first();
    return $any.attr('data-section-id') || null;
  }

  function getInventoryMap(sectionId) {
    if (!sectionId) return null;
    var el = document.getElementById('VariantInventory-' + sectionId);
    if (!el) return null;
    try {
      return JSON.parse(el.textContent || el.innerText || '{}');
    } catch (err) {
      return null;
    }
  }

  function getQtySelect(sectionId) {
    // Prefer section-specific selector
    if (sectionId) {
      var $q = $('#productQuantity-' + sectionId);
      if ($q.length) return $q;
    }
    // fallback
    return $('select[name="quantity"][id^="productQuantity-"]').first();
  }

  function rebuildQty($q, maxQty) {
    $q.empty();
    for (var i = 1; i <= maxQty; i++) {
      $q.append($('<option></option>').attr('value', i).text(i));
    }
    $q.val('1');
  }

  function applyQty(sectionId, variantId) {
    if (!sectionId || !variantId) return;

    var invMap = getInventoryMap(sectionId);
    if (!invMap) return;

    var inv = invMap[String(variantId)];
    if (typeof inv !== 'number') return; // don't overwrite if missing

    var $q = getQtySelect(sectionId);
    if (!$q.length) return;

    // Sold out: keep disabled + 1 option
    if (inv <= 0) {
      rebuildQty($q, 1);
      $q.prop('disabled', true);
      return;
    }

    var max = inv;
    if (CAP != null) max = Math.min(max, CAP);
    if (max < 1) max = 1;

    rebuildQty($q, max);
    $q.prop('disabled', false);
  }

  // Main hook: run after California empties the select
  $(document).on('variantChange', '[data-section-type="product"]', function (e) {
    var sectionId = getSectionIdFromEvent(e);
    var variantId = e && e.variant && e.variant.id ? e.variant.id : null;

    // Run after theme's updateAddToCartButton empties the select
    setTimeout(function () { applyQty(sectionId, variantId); }, 0);
    setTimeout(function () { applyQty(sectionId, variantId); }, 150);
  });

  // On page load: if qty is empty for some reason, populate from current variant
  $(function () {
    var $product = $('[data-section-type="product"]').first();
    if (!$product.length) return;

    var sectionId = $product.attr('data-section-id');
    if (!sectionId) return;

    var $q = getQtySelect(sectionId);
    if (!$q.length) return;

    // If already populated, leave it alone
    if ($q[0].options && $q[0].options.length > 0) return;

    var currentVariantId = $('#productSelect-' + sectionId).val();
    if (currentVariantId) applyQty(sectionId, currentVariantId);
  });
})(jQuery);
